import AvatarStack from '@alltrails/shared/denali/components/AvatarStack';
import ConnectionsModal from '@alltrails/communityapp/ConnectionsModal';
import { BelayUserConnection, UserConnectionListKey } from '@alltrails/shared/types/belay';
import { Context } from '@alltrails/shared/types/context';
import '@alltrails/modules/UserConnections/index.css';
import LanguageSupportUtil from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';

import * as styles from './styles/styles.module.scss';

type Props = {
  connections: BelayUserConnection[];
  count: number;
  title: JSX.Element;
  listKey: UserConnectionListKey;
  context: Context;
  onOverflowClick: () => void;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  userId?: number;
};

const BelayUserConnections = ({
  connections,
  count,
  title,
  listKey,
  context,
  onOverflowClick,
  showModal,
  setShowModal,
  userId
}: Props): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();
  const avatars = connections.map(connection => ({
    userId: Number(connection.user.id),
    userName: `${connection.user.firstName} ${connection.user.lastName}`,
    linkInfo: {
      href: LanguageSupportUtil.wrapUrlSafe(`/members/${connection.user.slug}`, languageRegionCode)
    },
    onClick: () => {}
  }));

  return (
    <div className={styles.avatarStack}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <span className={styles.count}>{count}</span>
      </div>
      <AvatarStack avatars={avatars} totalAvatars={count} onClick={onOverflowClick} testId="avatars" />
      {showModal && (
        <ConnectionsModal
          context={context}
          totalConnections={count}
          listKey={listKey}
          closeModal={() => setShowModal(false)}
          className={styles.connectionsModal}
          otherUserId={userId}
        />
      )}
    </div>
  );
};

export default BelayUserConnections;
